import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { createTheme } from '@mui/material/styles';
import { PROMETHEAN_BLUE, PROMETHEAN_NEUTRAL_DARK_GREY, PROMETHEAN_TEXT_HEADER, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT } from '../../..';
import { EMBERS_TABLE_HEADER_SORT_ICON_HEIGHT } from './resizableTableCell/resizableTableCellStyles';
export var HEADER_CELL_PADDING = {
  title: {
    left: 16,
    right: 0
  },
  icon: {
    left: 8,
    right: 0
  }
};
export var embersTableHeadTheme = createTheme({
  components: {
    MuiTableHead: {
      styleOverrides: {
        root: {
          '.MuiTableSortLabel-root:hover': {
            color: PROMETHEAN_TEXT_HEADER
          },
          '.MuiTableCell-root': {
            padding: 0,
            height: 48,
            '&.MuiTableCell-stickyHeader': {
              position: 'sticky'
            },
            '&.EmbersTable-HeaderCell-icon': {
              '.EmbersTable-Header-icon': {
                marginLeft: "-".concat(HEADER_CELL_PADDING.icon.left, "px")
              }
            },
            '&.EmbersTable-HeaderCell-title': {
              textTransform: 'uppercase',
              wordBreak: 'break-word'
            },
            '&.MuiTableCell-paddingCheckbox': {
              textAlign: 'center'
            },
            '.EmbersTable-Header-title': _objectSpread({}, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT),
            '.eyeColumnLaunchButton': {
              width: 48,
              height: 48,
              '&.Mui-focusVisible': {
                border: '2px solid ' + PROMETHEAN_BLUE
              }
            },
            '.icon-visibility': {
              cursor: 'pointer'
            },
            '&.EmbersTable-HeaderCell-noSortLabel': {
              paddingLeft: 16,
              '>div': {
                display: 'grid',
                alignItems: 'center',
                minHeight: EMBERS_TABLE_HEADER_SORT_ICON_HEIGHT
              },
              '&.MuiTableCell-alignCenter': {
                '>div': {
                  justifyItems: 'center'
                }
              }
            }
          },
          '&.EmbersTableHead-unclickable': {
            pointerEvents: 'none',
            '.eyeColumnLaunchButton': {
              color: PROMETHEAN_NEUTRAL_DARK_GREY
            }
          },
          '&:not(.EmbersTableHead-hasCheckboxColumn)': {
            'th:first-child': {
              '.MuiTableSortLabel-root': {
                '&.Mui-focusVisible': {
                  marginLeft: 2,
                  paddingLeft: 14
                }
              }
            }
          }
        }
      }
    }
  }
});